module.exports = __webpack_public_path__ + "static/media/noise-color.36498262.png";